:root,
.uic-theme-responsive {
  --uxc-app-header-height: 52px;
  --uxc-app-header-expandables-y-offset: 56px;
  --uxc-app-header-expandables-min-width: 300px;
  --uxc-app-header-z-index: 400;
  --uxc-app-header-bg-color: var(--uic-color-blue5);
  --uxc-app-header-separator-color: var(--uic-color-white);
  --uxc-app-header-launcher-width: 68px;
}

@media only screen and (min-width: 1024px) {
  .uic-theme-responsive {
    --uxc-app-header-height: 68px;
    --uxc-app-header-expandables-y-offset: 72px;
    --uxc-app-header-launcher-width: 85px;
  }
}
:root,
.uic-theme-responsive {
  --uxc-app-toast-notifications-z-index: 350;
}

/**
* @prop --uxc-app-header-height: height of the app header
* @prop --uxc-app-header-bg-color: background color of the app header
* @prop --uxc-app-header-separator-color: color of the separator line between vertical menus
* @prop --uxc-app-header-expandables-y-offset: vertical offset of header flyouts and dropdowns
* @prop --uxc-app-header-expandables-min-width: min width of header flyouts and dropdowns
* @prop --uxc-app-header-launcher-width: width of the app-launcher button
* @prop --uxc-app-header-z-index: z-index of the app header
 */
.uxc-app-header {
  width: 100%;
  height: var(--uxc-app-header-height);
  display: block;
  position: relative;
}
.uxc-app-header__inner {
  width: 100%;
  display: flex;
  justify-content: space-between;
  background: var(--uxc-app-header-bg-color);
  height: var(--uxc-app-header-height);
  z-index: var(--uxc-app-header-z-index);
  position: fixed;
}
.uxc-app-header .uic-sidebar {
  background: var(--uic-color-blue5);
  min-width: var(--uxc-app-header-expandables-min-width);
  top: var(--uxc-app-header-expandables-y-offset);
  z-index: var(--uic-flyout-z-index);
  transition: none;
}
.uxc-app-header .uic-sidebar--opened {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.uxc-app-header .uic-sidebar .uxc-app-header__sidebar-meta {
  border-top: 1px solid var(--uxc-app-header-separator-color);
}
.uxc-app-header .uic-sidebar .uic-menu-item[level="0"] > .uic-menu-item__item {
  background: var(--uic-color-blue5);
}
.uxc-app-header .uic-sidebar .uic-menu-item[level="0"] > .uic-menu-item__item:hover {
  background: var(--uic-menu-item-color-level-0-hover);
}
.uxc-app-header .uic-sidebar .uic-menu-item[level="1"] > .uic-menu-item__item {
  background: var(--uic-menu-item-color-level-1);
}
.uxc-app-header .uic-sidebar .uic-menu-item[level="1"] > .uic-menu-item__item:hover {
  background: var(--uic-menu-item-color-level-1-hover);
}
.uxc-app-header uic-flyout {
  position: fixed;
  top: var(--uxc-app-header-expandables-y-offset);
  min-width: var(--uxc-app-header-expandables-min-width);
}
.uxc-app-header .uic-menu:not(.uic-menu--vertical) .uic-menu-item[level="0"] > .uic-menu-item__dropdown {
  min-width: var(--uxc-app-header-expandables-min-width);
}
.uxc-app-header--is-active .uxc-app-header__navigation-left,
.uxc-app-header--is-active .uxc-app-header__navigation-right {
  opacity: 1;
}

.uxc-app-header__navigation-left {
  display: flex;
  position: relative;
  opacity: 0;
  transition: opacity 0.25s ease-in-out;
}
.uxc-app-header__navigation-left .uic-menu-item.uxc-app-header__icon-app-launcher {
  width: var(--uxc-app-header-launcher-width);
  display: flex;
  align-items: center;
  justify-content: center;
}
.uxc-app-header__navigation-left .uic-menu-item.uxc-app-header__icon-app-launcher > .uic-menu-item__item {
  width: 100%;
  background: var(--uic-color-blue4) !important;
}
.uxc-app-header__navigation-left .uic-menu-item.uxc-app-header__icon-app-launcher > .uic-menu-item__item .uic-menu-item__icon--expand {
  display: none;
}
.uxc-app-header__navigation-left .uic-menu-item.uxc-app-header__icon-app-launcher .uic-menu-item__icon {
  transform: scale(1.3);
}
.uxc-app-header__navigation-left .uic-menu-item[slug=trumpf-apps-shop]::before {
  content: "";
  left: 0;
  top: 0;
  width: 100%;
  height: 1px;
  background: var(--uxc-app-header-separator-color);
  position: absolute;
  z-index: 1;
}
.uxc-app-header__navigation-left .uxc-app-header__main-navigation {
  display: flex;
  position: relative;
}
.uxc-app-header__navigation-left .uxc-app-header__main-navigation-burger .uic-sidebar {
  background: var(--uxc-app-header-bg-color);
}

.uxc-app-header__navigation-right {
  right: 0;
  height: 100%;
  display: flex;
  position: absolute;
  opacity: 0;
  transition: opacity 0.25s ease-in-out;
}
.uxc-app-header__navigation-right .uxc-app-header__meta-navigation {
  display: flex;
  position: relative;
}
.uxc-app-header__navigation-right .uxc-app-header__meta-navigation .uic-menu-item[level="0"] {
  width: var(--uxc-app-header-height);
  display: flex;
  align-items: center;
  justify-content: center;
}
.uxc-app-header__navigation-right .uxc-app-header__meta-navigation .uic-menu-item[level="0"] > .uic-menu-item__item {
  width: 100%;
  justify-content: center;
}
.uxc-app-header__navigation-right .uxc-app-header__meta-navigation .ux-icon {
  font-size: var(--uic-icon-height);
}
.uxc-app-header__navigation-right .uxc-app-header__meta-navigation .ux-icon .ux-icon__inner {
  display: flex;
  align-items: center;
  justify-content: center;
}
.uxc-app-header__navigation-right .uxc-app-header__meta-navigation .uic-menu-item__dropdown {
  left: auto !important;
  right: 0;
}
.uxc-app-header__navigation-right .uxc-app-header__meta-navigation .uic-menu:not(.uxc-app-header__main-navigation-burger) .uic-menu-item[level="0"] > .uic-menu-item__item .uic-menu-item__icon--expand {
  display: none;
}
.uxc-app-header__navigation-right .uxc-app-header__meta-navigation .uic-menu:not(.uxc-app-header__main-navigation-burger) .uic-menu-item[level="0"] > .uic-menu-item__item .uic-menu-item__inner .uic-menu-item__label {
  display: none;
}
.uxc-app-header__navigation-right .uxc-app-header__meta-navigation .ux-notification-bell {
  background: none;
}
@media only screen and (max-width: 1023px) {
  .uxc-app-header__navigation-right .uxc-app-header__meta-navigation .ux-notification-bell .ux-notification-bell__badge {
    --ux-notification-bell-badge-margin-left-pos: -4px;
    transform: scale(0.8);
  }
}
.uxc-app-header__navigation-right .uxc-app-header__menu-container {
  display: flex;
}

.uic-menu.uxc-app-header__main-navigation-hidden {
  visibility: hidden;
  left: 0;
  top: 0;
  position: fixed;
  z-index: -1;
  display: inline-block;
}

.uxc-app-header__icon-app-launcher .uic-menu-item[level="1"] > .uic-menu-item__item,
.uxc-app-header__menu-sidebar .uic-menu-item[level="1"] > .uic-menu-item__item {
  background: var(--uic-menu-item-color-level-0);
}
.uxc-app-header__icon-app-launcher .uic-menu-item[level="1"]:hover > .uic-menu-item__item,
.uxc-app-header__menu-sidebar .uic-menu-item[level="1"]:hover > .uic-menu-item__item {
  background: var(--uic-menu-item-color-level-0-hover);
}
.uxc-app-header__icon-app-launcher .uic-menu-item[level="2"] > .uic-menu-item__item,
.uxc-app-header__menu-sidebar .uic-menu-item[level="2"] > .uic-menu-item__item {
  background: var(--uic-menu-item-color-level-1);
}
.uxc-app-header__icon-app-launcher .uic-menu-item[level="2"]:hover > .uic-menu-item__item,
.uxc-app-header__menu-sidebar .uic-menu-item[level="2"]:hover > .uic-menu-item__item {
  background: var(--uic-menu-item-color-level-1-hover);
}
.uxc-app-header__icon-app-launcher .uic-menu-item[level="3"] > .uic-menu-item__item,
.uxc-app-header__menu-sidebar .uic-menu-item[level="3"] > .uic-menu-item__item {
  background: var(--uic-menu-item-color-level-2);
}
.uxc-app-header__icon-app-launcher .uic-menu-item[level="3"]:hover > .uic-menu-item__item,
.uxc-app-header__menu-sidebar .uic-menu-item[level="3"]:hover > .uic-menu-item__item {
  background: var(--uic-menu-item-color-level-2-hover);
}

/** Fixes notification badge height */
uxc-app-header uic-badge .uic-badge__content {
  box-sizing: border-box;
  height: 18px;
}